<div mat-dialog-content>
  {{message}}
  <br />
  <br />
</div>
<div mat-dialog-actions fxLayout="row" fxLayoutAlign="space-around center">
  <button mat-raised-button (click)="onNoClick()">No</button>
  <button mat-raised-button color="primary" [mat-dialog-close]="true" cdkFocusInitial>Si</button>
</div>